import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { format, subDays } from 'date-fns';

const AutocompleteIssueTimestampCrossBorder = ({cqlFechaMax, cqlFechaMin, handleBackdropOpen, handleBackdropClose, handleDateSelect}) => {
  const [issueTimeOptions, setIssueTimeOptions] = useState([]);
  const [defaultIssueTime, setDefaultIssueTime] = useState(null);
  const [isUserInteraction, setIsUserInteraction] = useState(false); // Estado para diferenciar interacción manual

  useEffect(() => {
    handleBackdropOpen();

    // Generar las fechas fijas: D-0, D-1, D-2 en formato 'yyyy-MM-dd'
    const daysAgo = 1;
    const date = subDays(new Date(cqlFechaMin), daysAgo);
    const option = {
      label: `D-${daysAgo}: ${format(date, 'yyyy-MM-dd')}`,
      value: format(date, 'yyyy-MM-dd'),
    };

    setIssueTimeOptions([option]);

    // Seleccionar la primera opción automáticamente si no ha sido una interacción manual
    if (option && !isUserInteraction) {
      setDefaultIssueTime(option);
      handleDateSelect(option.value);
    }

    handleBackdropClose();
  }, [cqlFechaMax, cqlFechaMin, handleBackdropOpen, handleBackdropClose, handleDateSelect, isUserInteraction]);

  const handleManualChange = (event, newValue) => {
    setIsUserInteraction(true); // Marcar como interacción manual
    setDefaultIssueTime(newValue); // Permitir la selección manual del usuario
    handleDateSelect(newValue.value); // Llamar a handleDateSelect con la fecha seleccionada
  };

  // Reiniciar `isUserInteraction` cuando `cqlFechaMax` o `cqlFechaMin` cambien
  useEffect(() => {
    setIsUserInteraction(false);
  }, [cqlFechaMax, cqlFechaMin]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
      <Autocomplete
        options={issueTimeOptions}
        getOptionLabel={(option) => option.label}
        value={defaultIssueTime}
        // Si en algún momento deseas habilitar la selección manual, puedes descomentar la siguiente línea:
        // onChange={handleManualChange}
        disableClearable
        disabled  // <-- Aquí se desactiva el componente
        renderInput={(params) => (
          <TextField
            {...params}
            label="Issue Date CrossBorder"
            variant="outlined"
            sx={{
              backgroundColor: '#fafafa', // Fondo más claro y natural
              borderRadius: '8px',
              boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.08)', // Sombra sutil para un efecto más suave
              '.MuiInputBase-input': {
                padding: '10px',
                color: '#333',
                userSelect: 'none',
                pointerEvents: 'none', // También evita la interacción sobre el input
              },
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // Borde más claro
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#aaa', // Borde al pasar el mouse
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#bbb', // Borde al estar enfocado
              },
            }}
          />
        )}
        sx={{
          width: 180,
          '.MuiAutocomplete-endAdornment': {
            '.MuiSvgIcon-root': {
              color: '#1976d2',
            },
          },
        }}
      />
    </Box>
  );
};

export default AutocompleteIssueTimestampCrossBorder;
